import React from 'react'

function TopCharts() {
  return (
    <div className='flex flex-1 flex-col h-full justify-center items-center '>
      <img src={'https://media.tenor.com/NQfq1liFH-8AAAAd/byuntear-sad.gif'} alt={'cat'} 
      className='w-1/4 my-32'/>
    </div>
  )
}

export default TopCharts